import styled from '@emotion/styled'
import { css } from '@mui/material'
import { theme } from 'styles/theme/hav-theme'

export const Container = styled('form')`
  padding: 0;
`

export const ContainerFilter = styled.div`
  background-color: ${theme.colors.neutral.white};
  padding: ${theme.spacing.md};
  border-radius: ${theme.shapes.borderRadius.md};
  display: flex;
  flex-direction: column;
  margin-bottom: ${theme.spacing.md};
`

export const WrapperHeader = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${theme.spacing.lg};
`
export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: ${theme.spacing.sm};
`
export const HeaderItem = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  h1 {
    margin: 0;
    font-size: ${theme.typography.sizes['3md']};
  }

  @media screen and (max-width: ${theme.breakpoints.lg}px) {
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`

export const StructureInputs = styled.div`
  display: grid;
  justify-content: space-between;
  grid-template-columns: repeat(4, minmax(100px, 240px));
  width: 100%;
  gap: ${theme.spacing.xs};
`

export const SelectorWrapper = styled.div`
  display: grid;

  > div {
    display: grid !important;
    grid-template-columns: auto minmax(80px, 100%);
    width: 100%;
    align-items: center;
    gap: ${theme.spacing.xs};
  }

  @media screen and (max-width: ${theme.breakpoints.lg}px) {
    min-width: auto;
  }
`

export const SelectContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

type LabelFilterProps = { disabled?: boolean }

type FormFieldProps = {
  lastItem?: boolean
  flex?: boolean
}

export const FormField = styled.div<FormFieldProps>`
  display: ${({ flex }) => (flex ? 'flex' : 'grid')};
  grid-template-columns: 0.5fr minmax(80px, 1fr);
  gap: ${theme.spacing.xs};
  justify-content: end;

  ${({ lastItem }) => css`
    grid-column: ${lastItem ? '5' : 'unset'};
    @media screen and (max-width: ${theme.breakpoints.lg}px) {
      grid-column: ${lastItem ? '2' : 'unset'};
    }
  `};
`

export const LabelFilter = styled.div<LabelFilterProps>`
  display: flex;
  color: ${theme.colors.neutral.high};
  font-weight: ${theme.typography.weight.lg};
  font-size: ${theme.typography.sizes['2xs']};
  gap: ${theme.spacing.xs};
  align-items: center;
  white-space: nowrap;
  justify-self: end;

  ${({ disabled }) =>
    disabled &&
    css`
      color: ${theme.colors.neutral.medium};
    `}
`

export const FilterContentRow = styled.div`
  display: grid;
  grid-template-columns:
    minmax(100px, 20%)
    repeat(3, minmax(100px, 21%))
    minmax(100px, 18%);
  align-items: baseline;
  gap: ${theme.spacing.sm};
`

export const FilterContent = styled.div`
  display: grid;
  grid-template-rows: repeat(4, ${theme.spacing.lg});
  column-gap: ${theme.spacing.sm};
  row-gap: ${theme.spacing.xs};

  @media screen and (max-width: ${theme.breakpoints.lg}px) {
    grid-template-columns: repeat(2, minmax(100px, 1fr));
  }
`

export const WrapCheckboxField = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.sm};
  height: ${theme.spacing['15xm']};

  span {
    white-space: nowrap;
    padding-top: 0 !important;
    font-weight: ${theme.typography.weight.lg} !important;
  }
`

export const WrapHierarchyField = styled.div`
  display: flex;
  align-items: center;
`

export const ClearFiltersWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${theme.spacing.sm};
  justify-self: end;
  align-self: end;
  grid-column: 5;
  margin-bottom: -3px;
`

export const WrapTitleWithButton = styled.div`
  display: flex;
  gap: ${theme.spacing.lg};
  align-items: center;

  h1 {
    font-size: ${theme.typography.sizes.sm};
  }
`

export const MultiSelectWrapper = styled.div`
  display: flex;
  width: 100%;
`

export const ClientSapWrapper = styled.div`
  display: flex;
  gap: 4px;
`
